import { createStrictContext } from '@apeiron/temp'
import useFetchSkillGlossaryJson from '@src/hooks/json/useFetchSkillGlossaryJson'
import { SkillGlossary } from '@src/types/skill'
import { Dispatch, FC, ReactNode, SetStateAction, useState } from 'react'

const [ContextProvider, useSkillContext] =
  createStrictContext<ContextProps>('Skill')

export { useSkillContext }

export const SkillProvider: FC<Props> = (props: Props) => {
  const { children, defaultDetail = false } = props

  const { data: skillGlossary } = useFetchSkillGlossaryJson()

  const [showDetail, setShowDetail] = useState<boolean>(defaultDetail)

  return (
    <ContextProvider
      value={{
        showDetail,
        skillGlossary: skillGlossary || {},
        setShowDetail
      }}
    >
      {children}
    </ContextProvider>
  )
}

export type ContextProps = {
  showDetail: boolean
  skillGlossary: SkillGlossary
  setShowDetail: Dispatch<SetStateAction<boolean>>
}

export type Props = {
  children?: ReactNode
  defaultDetail?: boolean
}
